document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-science-tabs]").forEach((section) => {
    const items = Array.from(section.querySelectorAll("[data-science-tab]"));

    const setActiveHeights = () => {
      items.forEach((item) => {
        const content = item.querySelector("[data-science-tab-content]");
        if (!content) return;

        if (item.classList.contains("is-active")) {
          content.style.height = `${content.scrollHeight}px`;
        } else {
          content.style.height = "0px";
        }
      });
    };

    const closeItem = (item) => {
      const content = item.querySelector("[data-science-tab-content]");
      if (!content) return;

      content.style.height = `${content.scrollHeight}px`;

      requestAnimationFrame(() => {
        item.classList.remove("is-active");
        content.style.height = "0px";
      });
    };

    const openItem = (item) => {
      const content = item.querySelector("[data-science-tab-content]");
      if (!content) return;

      item.classList.add("is-active");
      content.style.height = "0px";

      requestAnimationFrame(() => {
        content.style.height = `${content.scrollHeight}px`;
      });
    };

    items.forEach((item) => {
      item.addEventListener("click", () => {
        if (item.classList.contains("is-active")) return;

        items.forEach((currentItem) => {
          if (
            currentItem !== item &&
            currentItem.classList.contains("is-active")
          ) {
            closeItem(currentItem);
          }
        });

        openItem(item);
      });
    });

    requestAnimationFrame(setActiveHeights);

    window.addEventListener("resize", setActiveHeights);
  });
});
